export default __webpack_public_path__ + "logo.f929156.png";